module.exports = __webpack_public_path__ + "img/contacts--promo.bf271ab.jpg";